var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_671_2566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6008 6.15315C21.487 5.69834 21.2551 5.28162 20.9287 4.94508C20.6023 4.60855 20.1928 4.36412 19.7416 4.23648C18.0933 3.83398 11.5 3.83398 11.5 3.83398C11.5 3.83398 4.90665 3.83398 3.25831 4.27482C2.80717 4.40245 2.39771 4.64688 2.07127 4.98342C1.74483 5.31995 1.51298 5.73667 1.39914 6.19148C1.09748 7.86431 0.949913 9.56128 0.958311 11.2611C0.947558 12.9737 1.09513 14.6836 1.39914 16.369C1.52465 16.8097 1.76169 17.2105 2.08737 17.5329C2.41304 17.8552 2.81635 18.0881 3.25831 18.209C4.90665 18.6498 11.5 18.6498 11.5 18.6498C11.5 18.6498 18.0933 18.6498 19.7416 18.209C20.1928 18.0813 20.6023 17.8369 20.9287 17.5004C21.2551 17.1639 21.487 16.7471 21.6008 16.2923C21.9002 14.6321 22.0477 12.9481 22.0416 11.2611C22.0524 9.54848 21.9048 7.83857 21.6008 6.15315Z",
    stroke: "#C1C6D7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34373 14.3948L14.8541 11.2611L9.34373 8.12732V14.3948Z",
    stroke: "#C1C6D7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_671_2566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.74ce31af43014c68b84f9d8ef20f8b2e.svg";
export { ForwardRef as ReactComponent };